import { useState } from "react";
import { JUSTIFICATIVA_MAX_LENGTH, JUSTIFICATIVA_REQUIRED_MESSAGE } from "../equipe-obra.constants";
import type { VerificacaoDialogProps } from "./types-verificacao-dialog";

export function useVerificacaoDialog({
  testId,
  title,
  subtitle,
  children,
  justificativaPlaceholder,
  linhas = 3,
  maxLength = JUSTIFICATIVA_MAX_LENGTH,
  rodapeLargo,
  onVoltar,
  onConfirmar,
}: VerificacaoDialogProps) {
  const [justificativa, setJustificativa] = useState("");
  const [tocada, setTocada] = useState(false);

  const erro = tocada && justificativa.trim() === "" ? JUSTIFICATIVA_REQUIRED_MESSAGE : null;

  const alterarJustificativa = (valor: string) => setJustificativa(valor.slice(0, maxLength));

  function confirmar() {
    setTocada(true);
    if (justificativa.trim() === "") return;
    onConfirmar(justificativa.trim());
  }

  return {
    justificativa,
    alterarJustificativa,
    erro,
    confirmar,
    testIds: {
      dialog: `${testId}-dialog`,
      justificativa: `${testId}-justificativa`,
      justificativaErro: `${testId}-justificativa-error`,
    },
    compacto: linhas === 1,
    title,
    subtitle,
    children,
    justificativaPlaceholder,
    linhas,
    maxLength,
    rodapeLargo,
    onVoltar,
  };
}
